import { render, staticRenderFns } from "./ButtonComposableProduct.vue?vue&type=template&id=75602866&scoped=true&"
import script from "./ButtonComposableProduct.vue?vue&type=script&lang=js&"
export * from "./ButtonComposableProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75602866",
  null
  
)

export default component.exports